import { TIllustrationProps } from '@/common/components/Illustrations/types';
import { Svg, Path } from 'react-native-svg';

export const LogoVisa = ({
  width = 92,
  height = 31,
  className,
}: TIllustrationProps) => {
  return (
    <Svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 92 31"
      fill="none"
    >
      <Path
        d="M35.2339 1.27385L23.2634 29.7426L15.4546 29.7426L9.56457 7.02741C9.20746 5.627 8.89796 5.1143 7.80757 4.52566C6.03153 3.56673 3.09844 2.66477 0.522461 2.1046L0.698637 1.2786L13.269 1.2786C14.8689 1.2786 16.3116 2.34196 16.6735 4.18386L19.7828 20.6565L27.4726 1.2786L35.2339 1.27385ZM65.8266 20.4524C65.8599 12.9376 55.4036 12.5246 55.4751 9.16838C55.4989 8.14774 56.475 7.06064 58.6081 6.78531C59.6652 6.64764 62.584 6.5432 65.8885 8.05755L67.1836 2.01915C65.4076 1.37829 63.1173 0.756409 60.2746 0.756409C52.9753 0.756409 47.8328 4.62535 47.79 10.1653C47.7424 14.2621 51.4563 16.5502 54.2561 17.9127C57.1368 19.3083 58.1034 20.2055 58.0891 21.4493C58.0701 23.3577 55.7941 24.2027 53.6657 24.2359C49.9517 24.2929 47.7995 23.2342 46.0806 22.4367L44.7426 28.6745C46.4663 29.4625 49.6565 30.1509 52.9562 30.1888C60.727 30.1936 65.8028 26.3674 65.8266 20.4524ZM85.1107 29.7473L91.9435 29.7473L85.9773 1.27385L79.673 1.27385C78.2541 1.27385 77.059 2.09511 76.5304 3.3626L65.4456 29.7426L73.2021 29.7426L74.7401 25.4891L84.2203 25.4891L85.1107 29.7473ZM76.8685 19.6596L80.7587 8.969L82.9966 19.6596L76.8685 19.6596ZM45.7854 1.27385L39.6764 29.7426L32.2913 29.7426L38.4003 1.27385L45.7854 1.27385Z"
        fill="#1434CB"
      />
    </Svg>
  );
};
